
import { Note } from "@models/note.model.ts";
import { NoteSerializer } from "@models/serializers/noteSerializer.ts";
import { httpRequest } from "../../http";

export class CommandUpdateNote {

    async run(notebookId: number, note: Note) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}/pages/${note.id}/`
        try {
            const response = await httpRequest<any>(url, {
                method: "PUT",
                body: {
                    parent_id: -1,
                    title: note.title,
                    content: note.content,
                    // Which campaign the note is about (MPN-1640). Always sent, so an
                    // explicit null moves a note back to engagement-wide; the server
                    // reads a missing value as "leave it alone", which is what every
                    // other caller wants.
                    launch_id: note.launch_id ?? null },
            });
            return this.deserialize(response);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Note []{
        const serializer = new NoteSerializer();
        return serializer.deserialize(data);
    }

}

